<section class="section-title">

    <div class="section-title-image">
        <img class="owner-image" src="assets/img/owner.png" />
    </div>

    <div class="section-title-text">
        <h1 i18n="@@owneradd_title">Aggiungi gestore</h1>
    </div>

</section>

<section>

    <mat-tab-group [animationDuration]="'0ms'">

        <mat-tab label={{createNewOwnerString}}>
            <div  id="owner-add-card">

                <div class="control-card-header">
                    <ng-container i18n="@@owneradd_data_title">Dati gestore</ng-container> 
                </div>
        
                <div class="control-card-content">
        
                    <form [formGroup]="ownerForm">
                        <table class="simple-table owner-add-table">
                            <tr>
                                <td width="180px" class="text-dark" i18n="@@owneradd_name">Nome visualizzato</td>
                                <td><input id="name-input" formControlName="name" required></td>
                            </tr>
                            <tr>
                                <td class="text-dark" i18n="@@owneradd_email">Email</td>
                                <td><input id="email-input" formControlName="email" type="email" required></td>
                            </tr>
                            <tr>
                                <td class="text-dark" i18n="@@owneradd_password">Password</td>
                                <td><input id="password-input" formControlName="password" type="password" required></td>
                            </tr>
                            <tr>
                                <td class="text-dark" i18n="@@owneradd_password_again">Ripeti password</td>
                                <td><input id="password2-input" formControlName="password2" type="password" required></td>
                            </tr>
                        </table>
                    </form>
        
                    <a (click)="createOwner()" class="button owner-add-button">
                        <ng-container i18n="@@owneradd_create_owner">Aggiungi</ng-container> <span><fa-icon icon="save"></fa-icon></span>
                    </a>
                    <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="nameError"  i18n="@@owneradd_invalid_name"> 
                        Devi inserire un nome valido 
                    </p>
                    <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="emailError"  i18n="@@owneradd_invalid_email"> 
                        Devi inserire un indirizzo email valido 
                    </p>
                    <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="password1Error"  i18n="@@owneradd_invalid_password"> 
                        Devi inserire una password valida (almeno 8 caratteri)
                    </p>
                    <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="passwordsNotMatchError"  i18n="@@owneradd_passwords_dont_match"> 
                        Le password inserite non coincidono
                    </p>
                
                    <app-loading-screen #owneraddloader [loading]="false" [showtext]="false"></app-loading-screen>
        
                </div>
        
            </div>

        </mat-tab>

        <mat-tab label={{promoteOwnerString}}>

            <div  id="owner-add-card">

                <div class="control-card-header">
                    <ng-container i18n="@@owneradd_promote_user_title">Dati utente</ng-container> 
                </div>
        
                <div class="control-card-content">
        
                    <form [formGroup]="promoteUserForm">
                        <table class="simple-table owner-add-table">
                            <tr>
                                <td width="180px" class="text-dark" i18n="@@owneradd_name">Nome visualizzato</td>
                                <td><input id="name-input" formControlName="name" required></td>
                            </tr>
                            <tr>
                                <td class="text-dark" i18n="@@owneradd_used_email">Email utilizzata</td>
                                <td><input id="email-input" formControlName="email" type="email" required></td>
                            </tr>
                        </table>
                    </form>
        
                    <a (click)="promoteUser()" class="button owner-add-button">
                        <ng-container i18n="@@owneradd_create_owner">Aggiungi</ng-container> <span><fa-icon icon="save"></fa-icon></span>
                    </a>
                    <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="nameErrorPromote" > 
                        Devi inserire un nome valido 
                    </p>
                    <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="emailErrorPromote" > 
                        Devi inserire un indirizzo email valido 
                    </p>

                    <app-loading-screen #owneraddloader [loading]="false" [showtext]="false"></app-loading-screen>
        
                </div>
        
            </div>

        </mat-tab>


    </mat-tab-group>



</section>
